module.exports = __webpack_public_path__ + "img/ico_move.4fa3a252.svg";